export const LP_TEMPLATE_STUDIO_PATH = "/lp-express-template-studio";

// These old URLs identify a global session, not a brand resource. Recognize
// them before brand slug resolution so even a retired/unknown slug still works.
export function globalTemplateStudioPath(path: string): string | null {
  const match = path.match(/^\/brands\/[^/]+\/lp-express-template-studio((?:\/new|\/sessions\/[^/]+)?)(?:\/)?$/);
  return match ? `${LP_TEMPLATE_STUDIO_PATH}${match[1]}` : null;
}
